// extracted by css-extract-rspack-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_dka","cls2":"CollapsedActivityPreview-cls2__bK CollapsedActivityPreview-cls1_dka"};